// Chakra imports
import { 
  Box, 
  Text, 
  Input, 
  Select, 
  Textarea,
  useColorModeValue 
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React from "react";

export default function EditableInformation(props) {
  const { 
    title, 
    value, 
    isEditing = false,
    field,
    onFieldChange,
    type = "text",
    options = [],
    ...rest 
  } = props;

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const bg = useColorModeValue("white", "navy.700");

  const handleChange = (e) => {
    if (onFieldChange && field) {
      onFieldChange(field, e.target.value);
    }
  };

  const renderInput = () => {
    if (type === "select") {
      return (
        <Select
          value={value || ""}
          onChange={handleChange}
          placeholder="Seleccionar..."
          size="sm"
          color={textColorPrimary}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      );
    }

    if (type === "date") {
      return (
        <Input
          type="date"
          value={value || ""}
          onChange={handleChange}
          size="sm"
          color={textColorPrimary}
        />
      );
    }

    if (type === "textarea") {
      return (
        <Textarea
          value={value || ""}
          onChange={handleChange}
          placeholder={title}
          size="sm"
          color={textColorPrimary}
          rows={3}
        />
      );
    }

    return (
      <Input
        type={type}
        value={value || ""}
        onChange={handleChange}
        placeholder={title}
        size="sm"
        color={textColorPrimary}
      />
    );
  };

  return (
    <Card bg={bg} {...rest}>
      <Box>
        <Text fontWeight='500' color={textColorSecondary} fontSize='sm'>
          {title}
        </Text>
        {isEditing ? (
          renderInput()
        ) : (
          <Text color={textColorPrimary} fontWeight='500' fontSize='md'>
            {value || "Sin información"}
          </Text>
        )}
      </Box>
    </Card>
  );
}
